import { render } from "./DadosEmpresa.vue?vue&type=template&id=22a7fdaa"
import script from "./DadosEmpresa.vue?vue&type=script&lang=js"
export * from "./DadosEmpresa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__